// extracted by mini-css-extract-plugin
export default {"rating":"Cy-z","numberOfStars":"Dy-z","count":"Ey-z","barGraphSpacing":"Fy-z","barGraph":"Gy-z"};